const config = {
  stores: {
    "milligram-prod": {
      shopify_domain: "milligram-prod",
      storefront_access_token: "07625c505763877f13aa8328c1eab075",
      storefront_version: "2024-10",
      url: "https://milligram.com/",
      region: "AU",
    },
    "milligram-development": {
      shopify_domain: "milligram-development",
      storefront_access_token: "eea56c64d7736053c14fb02f52abc102",
      storefront_version: "2024-10",
      url: "https://milligram-development.myshopify.com/",
      region: "AU",
    },
    presonalisationIds: {
      Gold: "46317670203579",
      Silver: "46317670236347",
      Blind: "46317670269115",
      Baskerville: "46317672038587",
      Optima: "46317672071355",
      "Gill Sans": "46317672104123",
    },
  },
  prismic: {
    repoName: "milligram",
    accessToken: "26dd3e6ed39cebdc3f3fc453c9af4601",
    apiEndpoint: "https://milligram.cdn.prismic.io/api/v2",
  },
  reactify: {
    includeFields: ["storefrontId", "presentment_price_ranges", "images", "tags", "variants.*", "vendor", "image", "title", "variant_options", "handle", "options", "tags", "inventory_total", "id"],
    excludeFields: [],
  }
};

export type Config = ReturnType<typeof config>;

export default config;
